<template>
  <b-navigation class="is-primary-bg">
    <template v-slot:brand>
      <router-link to="/">
        <div class="level">
          <div class="level-item is-padded-small">
            <img
              class="has-background-white has-margin-horizontal-small is-block"
              :src="logo"
              alt="Toxi Triage"
              width="200"
              heigth="120"
            >
            <h1 class="is-size-3 is-size-5-mobile has-text-white has-text-weight-semibold">
              CBRN TOOLBOX
            </h1>
          </div>
        </div>
      </router-link>
      <div class="navbar-item no-top-bottom-padding flex-pull-right">
        <b-dropdown
          id="role-dropdown"
          aria-role="list"
          :mobile-modal="false"
          position="is-bottom-left"
        >
          <div
            class="level"
            slot="trigger"
          >
            <span class="level-item">
              <span class="is-padded-small is-hidden-mobile">I'm a {{ selectedRoleName }}</span>
              <img
                :src="getRoleImage(selectedRole)"
                :alt="selectedRoleName"
              >
              <font-awesome-icon
                class="has-margin-horizontal-small is-hidden-mobile"
                icon="caret-down"
                size="1x"
              />
            </span>
          </div>
          <b-dropdown-item
            @click="SET_ROLE(idx)"
            v-for="(role, idx) in roles"
            :key="role"
            aria-role="listitem"
            paddingless
            radiusless
          >
            <div class="level is-padded-small is-mobile">
              <div class="level-item">
                <img
                  :src="getRoleImage(idx)"
                  :alt="selectedRoleName"
                >
              </div>
              <div class="level-item">{{ role }}</div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </template>
    <template v-slot:links="linkProps">
      <div class="navbar-start">
        <router-link
          to="/observations"
          class="navbar-item"
          @click.native="linkProps.close"
        >
          <span class="is-padded-small">
            <font-awesome-icon
              icon="filter"
              class="fa-sm"
            />
          </span>
          Observations
        </router-link>
        <router-link
          to="/agents"
          class="navbar-item"
          @click.native="linkProps.close"
        >
          <span class="is-padded-small">
            <font-awesome-icon
              icon="search"
              class="fa-sm"
            />
          </span>
          Agents
        </router-link>
        <router-link
          class="navbar-item"
          to="/material-portal"
          @click.native="linkProps.close"
        >
          <span class="is-padded-small">
            <font-awesome-icon
              icon="book-open"
              class="fa-sm"
            />
          </span>
          Material portal
        </router-link>
        <router-link
          to="/"
          class="navbar-item"
          @click.native="linkProps.close"
        >Home</router-link>
        <a
          @click="logout"
          class="navbar-item"
        >Log out</a>
      </div>
    </template>
  </b-navigation>
</template>

<script>
import logo from '@/assets/logo.png'
import firstResponderImage from '@/assets/first-responder.png'
import deconImage from '@/assets/decon.png'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { SET_ROLE } from '@/store/mutation-types'
import { rolesEnum } from '@/store'

export default {
  data: function () {
    return {
      logo,
      firstResponderImage,
      deconImage
    }
  },
  computed: {
    ...mapGetters(['selectedRoleName', 'selectedRole', 'roles']),

  },
  methods: {
    ...mapMutations([SET_ROLE]),
    ...mapActions(['logout']),
    getRoleImage (role) {
      switch (role) {
        case rolesEnum.FIRST_RESPONDER:
          return firstResponderImage
        case rolesEnum.DECON_OR_SAMPLER:
          return deconImage
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/bulma-base.scss";
#nav-heading {
  padding-left: 5px;
}

#role-dropdown {
  .dropdown-content {
    border-radius: 0px;
    padding: 0px;

    .dropdown-item {
      border-bottom: 1px solid $dark;
    }
    .dropdown-item:last-child {
      border-bottom: 0px;
    }
  }
  .dropdown-menu {
    width: 100%;
  }
}

.navbar-menu {
  padding: 0px !important;
}

.navbar-start {
  @include desktop {
    .navbar-item:last-child {
      margin-right: 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../../assets/colorpallet.scss";

.navbar {
  .navbar-item {
    cursor: pointer;
    img {
      max-height: 3rem;
    }
  }

  @include mobile {
    .no-top-bottom-padding {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    .navbar-start .navbar-item {
      padding: 0.5rem 0.75rem !important;
      border-bottom: 1px solid $dark;
    }
  }
}
</style>
